export const selectSubscriptionText = {
  selectTitle: 'Choose the Right tapybl Plan for You',
  subtitle: 'From Individual Creators to Enterprises, We’ve Got You Covered',
  underTierInfo:
    "tapybl offers a range of plans tailored to your needs. Whether you're experimenting with our Creator Trial or managing advanced learning experiences with the Enterprise plan, you’ll find the perfect fit to create, manage, and analyze your content.",
  fullList: 'Full List of Features',
  tableFootnote: '* Optional features. Contact us for pricing.',
};
